// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleFoundationLine_root__2xUF4","foundationLineText":"ArticleFoundationLine_foundationLineText__SMyt3"};